import SpacePath from "components/SpacePath";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsPolicy } from "../types";

const SpaceDetailsPoliciesInheritedFromCell = ({
  item: policy,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsPolicy>) => (
  <TableSimpleCell {...cellProps}>
    {policy.inheritedFrom ? (
      <SpacePath spaceId={policy.inheritedFrom.id} fallbackName={policy.inheritedFrom.name} />
    ) : (
      <TableCellEmpty />
    )}
  </TableSimpleCell>
);

export default SpaceDetailsPoliciesInheritedFromCell;
